export class CookieKeys {
    static readonly addToFavouritesProductCode = 'addToFavouritesProductCode';
    static readonly showLoginDisabledPopup = 'showLoginDisabledPopup';
    static readonly showOrderingDisabledPopup = 'showOrderingDisabledPopup';
    static readonly showSponsorPopup = 'showSponsorPopup';
}
